import { gql } from "@/services/httpAdapter";

export const RepairOrderFragment = gql`
	fragment RepairOrder on RepairOrderGeneral {
		_id
		repairOrderNumber
		repairOrderCreationDate
		locationId
		commissionCycleId
		payPeriodId
		vinNumber
		bodId
		branchId
		storeId
		repairOrder {
			repairOrderRecord {
				transactionType
				transactionPayType
				rogen {
					customerNumber
					customerName
					advisorNumber
					dispatchNumber
					tagNumber
					appointmentNumber
					departmentNumber
					vehiclePriority
					repairOrderStatus
					vehicleMakePrefix
					carlineDescription
					mileageIn
					mileageOut
					repairOrderCreatedAt
					promiseDate
					voidDate
					customerInvoiceDate
					warrantyPostDate
					finalPostDate
					customerRepairOrderTotalAmount
					warrantyRepairOrderTotalAmount
					internalRepairOrderTotalAmount
					repairOrderCommentInfo {
						repairOrderComment
					}
					techRecommends {
						techRecommend
					}
					recommendedService {
						recommendedServiceOperationCode
						recommendedServiceOperationCodeDescription
						recommendedServicePerformFlag
					}
				}
				repairOrderLabor {
					repairOrderAmts {
						payType
						amountType
						taxableAmount
						nonTaxableAmount
						dealerCost
					}
					operationCodeLaborInfo {
						operationCode
						operationCodeDescription
						jobNumber
						techNote
						upSellFlag
						jobStatus
						techInfo {
							customerTechnicianRate
							internalTechnicianRate
							warrantyTechnicianRate
							technicianHours
							technicianName
							technicianNumber
						}
						billTimeRateHrs {
							billRate
						}
						cccStmsts {
							cause
							complaint
							correction
						}
						repairOrderAmts {
							dealerCost
							payType
							totalAmount
						}
					}
				}
				repairOrderPart {
					partInfoByJob {
						operationCode
						jobNumber
						repairOrderAmts {
							amountType
							dealerCost
							nonTaxableAmount
							payType
							taxableAmount
						}
						partDetail {
							partNumber
							partNumberDescription
							sequenceNumber
						}
					}
				}
				repairOrderGog {
					allGogTotalAmts {
						allTotalAmtType
						repairOrderAmounts {
							amountType
							customerPrice
							dealerCost
						}
					}
				}
				repairOrderMisc {
					customerPartsTotal
					warrantyPartsTotal
					internalPartsTotal
					customerLaborTotal
					warrantyLaborTotal
					internalLaborTotal
					repairOrderAmts {
						payType
						amountType
						taxableAmount
						nonTaxableAmount
						totalAmount
					}
				}
				repairOrderSub {
					allSubTotalAmts {
						allTotalAmountType
						repairOrderAmts {
							payType
							amountType
							taxableAmount
							nonTaxableAmount
							dealerCost
						}
					}
					subInfoByJob {
						operationCode
						jobNumber
						subDetail {
							subletDescription
							subletPurchaseOrderNumber
						}
					}
				}
			}
			serviceVehicle {
				vehicle {
					makePrefix
					vehicleMake
					vehicleYear
					modelDescription
					carline
					externalColorDescription
					internalColorDescription
					makeName
					vehicleDetail {
						licenceNumber
					}
				}
				vehicleServiceInfo {
					stockId
					salesmanNumber
					modelMaintenanceNumber
					inServiceDate
					deliveryDate
					deliveryOdometer
					serviceDays
					lastActivityDate
					firstRepairOrderDate
					lastRepairOrderNumber
					lastRepairOrderDate
					lastRepairOrderOdometer
					numberOfVisits
				}
			}
			customerRecord {
				contactInfo {
					ibFlag
					nameRecordId
					lastName
					firstName
					middleName
					address {
						zip
					}
					phone {
						type
						number
						extension
					}
					email {
						mailTo
					}
				}
			}
		}
		transactionTypeDate
		createdAt
		updatedAt
	}
`;
